import React from 'react';
import './Event_about.css';
import { Link } from "react-scroll";

const About = () => {
    const state = {
        About_item: [
            {
                id: '01',
                text: 'JDK 19 latest updates (record patterns, structured concurrency API, Vector API) ',
            },
            {
                id: '02',
                text: 'Java and Cloud Development (AWS, GCP, Azure)',
            },
            {
                id: '03',
                text: 'Microservices and Spring Boot framework',
            },
            {
                id: '04',
                text: 'Security and Vulnerability Management - Azul, Snyk',
            },
            {
                id: '05',
                text: 'Understand Project Loom model',
            },
            {
                id: '06',
                text: 'Continuous Integration/Continuous Deployment automation techniques',
            },
            {
                id: '07',
                text: 'Native Cloud Development with Java and Quarkus',
            },
            {
                id: '08',
                text: 'Chaos Engineering for resilience and robustness',
            },
            {
                id: '09',
                text: 'Opentelemetry in JVM - how to catch metrics, traces and logs',
            },
            {
                id: '10',
                text: 'Performance tuning and monitoring - Flight Recorder',
            },
            {
                id: '11',
                text: 'Orchestration vs Choreography architecture patterns',
            },
            {
                id: '12',
                text: 'GraphQL in Spring Boot environment',
            },
            {
                id: '13',
                text: 'Spring Security and best practices',
            },
            {
                id: '14',
                text: 'Java libraries and frameworks (Hibernates, Quarkus, Spring 6.0, Hibernate 6.0, Helidon, Micronaut)',
            },
        ],
    };

    const renderAbout_item = (item, i) => {
        return (
            <div className='about_item' key={`about_item-${i}`}>
                <p className='about_item-numb'>{item.id}</p>
                <p className='about_item-text'>{item.text}</p>
            </div>
        );
    };

    return (
        <section className="about_wrap black">
            <div className='container about'>
                <div className="about_content">
                    <h2 className='about_title'>What event <span className='title_gradient'>is</span> about</h2>
                    <Link
                        activeClass="active"
                        to='tickets'
                        spy={true}
                        smooth={true}
                        offset={80}
                        className='button about_btn--pc'
                    >
                        GET TICKET
                    </Link>
                </div>
                <div className="about_block">
                    {state.About_item.map((item, i) => renderAbout_item(item, i))}
                </div>
                <Link
                    activeClass="active"
                    to='tickets'
                    spy={true}
                    smooth={true}
                    offset={80}
                    className='button about_btn--mob'
                >
                    GET TICKET
                </Link>
            </div>
        </section>
    );
};

export default About;